import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import {
  Dialog,
  DialogActions,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  CircularProgress,
} from "@mui/material";

function PledgeModal() {
  const { userData, pledgeRequired, currentPolicy, submitPledgeAcceptance } =
    useContext(AuthContext);

  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [agreementHTML, setAgreementHTML] = useState("");

  const user = userData?.[0];

  useEffect(() => {
    if (currentPolicy?.agreement) {
      let formatted = currentPolicy.agreement.replace(
        /\*\*(.*?)\*\*/g,
        "<strong>$1</strong>"
      );
      formatted = formatted.replace(/\n/g, "<br />");
      setAgreementHTML(formatted);
    }
  }, [currentPolicy]);

  const pad = (n) => String(n).padStart(2, "0");
  const today = new Date();
  const formattedDate = `${pad(today.getDate())}-${pad(today.getMonth() + 1)}-${today.getFullYear()}`;

  const handleAccept = async () => {
    setLoading(true);
    setError(null);
    try {
      await submitPledgeAcceptance(currentPolicy?.id);
    } catch {
      setError("Failed to accept pledge. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={pledgeRequired} maxWidth="md" fullWidth>
      <div style={{ padding: "40px 40px 0 40px" }}>
        <div
          style={{ maxHeight: "50vh", overflowY: "auto", marginBottom: "16px" }}
          dangerouslySetInnerHTML={{ __html: agreementHTML }}
        />
      </div>

      <div style={{ padding: "0 40px 40px 40px" }}>
        <Box mt={2}>
          <Typography>
            Name:{" "}
            <strong style={{ color: "#d32f2f" }}>
              {user?.EM_FirstName} {user?.EM_LastName}
            </strong>
          </Typography>
          <Typography>
            Employee ID:{" "}
            <strong style={{ color: "#d32f2f" }}>{user?.EM_EmpID}</strong>
          </Typography>
          <Typography>
            Date:{" "}
            <strong style={{ color: "#d32f2f" }}>{formattedDate}</strong>
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                style={{ color: "#50145A" }}
              />
            }
            label="I have read and accept the data protection policy."
            style={{ marginTop: "12px" }}
          />
          {error && (
            <Typography style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
              {error}
            </Typography>
          )}
        </Box>
        <DialogActions style={{ paddingRight: 0, marginTop: "16px" }}>
          {loading ? (
            <CircularProgress size={24} style={{ color: "#50145A" }} />
          ) : (
            <Button
              variant="contained"
              disabled={!isChecked}
              onClick={handleAccept}
              style={{
                backgroundColor: isChecked ? "#6A1B9A" : "#ccc",
                color: "#fff",
              }}
            >
              Accept
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default PledgeModal;
